import { Component, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { CercaService } from '../cerca.service';
import * as moment from 'moment';

@Component({
  selector: 'app-cercador-activitats',
  templateUrl: './cercador-activitats.component.html',
  styleUrls: ['./cercador-activitats.component.css']
})
export class CercadorActivitatsComponent implements OnInit {

  settings = {
    noDataMessage: 'No s\'han trobat esplais amb la teva cerca :(',
    actions: {
      add: false,
      edit: false,
      delete: false
    },
    columns: {
      nom: {
        title: 'Nom',
        filter: false,
      },
      esplai: {
        title: 'Esplai',
        type: 'string',
        filter: false,
      },
      localitat: {
        title: 'Localitat',
        filter: false,
      },
      tipus: {
        title: 'Tipus d\'activitat',
        filter: false,
        type: 'html',
        valuePrepareFunction: (v) => {
          let s = '';
          v.forEach(e => {
            s += e;
            s += '<br>';
          });
          return s;
        },
      },
      dates: {
        title: 'Dates',
        filter: false,
        valuePrepareFunction: (v) => {
          const i = moment(v[0]).locale('ca-es');
          const f = moment(v[1]).locale('ca-es');
          if (i.month() === f.month()) {
            return `${i.date()} - ${f.date()} ${i.format('MMMM')}`;
          } else {
            return `${i.date()} ${i.format('MMMM')} - ${f.date()} ${f.format('MMMM')}`;
          }
        },
      },
      on: {
        title: 'On es realitza?',
        filter: false,
        valuePrepareFunction: v => {
          return v.name || v.vicinity || v.adre;
        },
      },
      preu: {
        title: 'Preu',
        filter: false,
        type: 'number',
        valuePrepareFunction: (v) => {
          if (v === 0) {return '-'; } else {return v; }
        },
      },
      contacte: {
        title: 'Contacte',
        filter: false,
      }
    }
  };

  loading = false;
  primeraCerca = false;

  rang;
  tipus;

  source: LocalDataSource = new LocalDataSource();

  constructor(private service: CercaService) { }

  ngOnInit() {
  }

  cerca() {
    console.log(this.rang, this.tipus);
    this.loading = true;
    this.service.cercaActuacions(this.tipus, this.rang.start, this.rang.end)
      .subscribe(r => {
        this.source.load(r);
        this.primeraCerca = true;
        this.loading = false;
      }, e => {
        console.error(e);
        this.loading = false;
      });
  }

}
